<template>
  <div class="d-flex justify-content-center align-items-center">
    <component
      @download="downloadFile"
      :is="activeComponent"
      :src.sync="fileSrc"
    />
  </div>
</template>

<script>
import { hasError } from "@/utils/utils";
import axios from "@axios";
import { downloadFile } from "@/utils/utils";
export default {
  props: {
    fileEp: String,
  },
  components: {
    FileView: () => import("./FileView.vue"),
    FileError: () => import("./FileError.vue"),
    FileLoading: () => import("./FileLoading.vue"),
    FileUnauthorized: () => import("./FileUnauthorized.vue"),
  },
  data() {
    return {
      activeComponent: "FileLoading",
      fileSrc: null,
      fileBlob: null,
    };
  },
  methods: {
    downloadFile() {
      downloadFile(this.fileBlob, "file");
    },
    async fetchFile(ep) {
      if (ep.includes("blob")) {
        this.fileSrc = ep;
        this.activeComponent = "FileView";
      } else {
        try {
          this.activeComponent = "FileLoading";
          const res = await axios.get(ep, { responseType: "blob" });
          if (hasError(res.status)) throw res.status;
          this.fileBlob = res.data;
          this.fileSrc = URL.createObjectURL(res.data);
          this.activeComponent = "FileView";
        } catch (err) {
          console.log(err);
          if (err === 403) this.activeComponent = "FileUnauthorized";
          else this.activeComponent = "FileError";
        }
      }
    },
  },
  watch: {
    fileEp: {
      immediate: true,
      handler(val) {
        this.fetchFile(val);
      },
    },
  },
};
</script>
